import { createEvent, EventAttributes } from 'ics';

export const downloadIcsFile = async (
  event: EventAttributes,
  fileName: string
) => {
  const filename = `${fileName}.ics`;
  const file = await new Promise((resolve, reject) => {
    createEvent(event, (error, value) => {
      if (error) {
        reject(error);
      }

      resolve(new File([value], filename, { type: 'text/calendar' }));
    });
  });
  const url = URL.createObjectURL(file as Blob);

  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;

  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);

  URL.revokeObjectURL(url);
};
